import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { convertLegacyRouteRef } from '@backstage/core-compat-api';
import { homePlugin } from '@backstage/plugin-home';

/**
 * Override the home plugin's page to render our custom HomePage at '/'.
 * The auto-discovered page:home registers at '/home' with a widget-based layout,
 * but we use CustomHomepageGrid with custom card extensions, so we render
 * our own page component directly.
 */
const homePage = PageBlueprint.make({
  params: {
    path: '/',
    title: 'Home',
    noHeader: true,
    routeRef: convertLegacyRouteRef(homePlugin.routes.root),
    loader: () =>
      import('../../components/home/HomePage').then(m => <m.HomePage />),
  },
});

export const homePageModule = createFrontendModule({
  pluginId: 'home',
  extensions: [homePage],
});
